import { useSharedModelController } from '../../hooks/use-shared-model-controller';
import { DocumentationController } from './documentation-controller';
import { initialDocumentation } from './models/documentation-list';

export function useDocumentation() {
  const { model: documentationModel, delegate: documentationDelegate } = useSharedModelController(
    initialDocumentation,
    DocumentationController,
    {
      useTelemetry: true,
    }
  );

  return { documentationModel, documentationDelegate };
}
